import type { OptionDisplay, SelectAsyncOptionDisplayStyle } from '@hero/web-hooks';

/** Tailwind classes for avatar and selected dot per optionDisplayStyle.color */
export const OPTION_DISPLAY_COLOR_MAP: Record<
  NonNullable<SelectAsyncOptionDisplayStyle['color']>,
  { avatarBg: string; avatarText: string; dot: string }
> = {
  blue: { avatarBg: 'bg-blue-100', avatarText: 'text-blue-600', dot: 'bg-blue-600' },
  primary: { avatarBg: 'bg-primary/10', avatarText: 'text-primary', dot: 'bg-primary' },
  purple: { avatarBg: 'bg-purple-100', avatarText: 'text-purple-600', dot: 'bg-purple-600' },
  green: { avatarBg: 'bg-green-100', avatarText: 'text-green-600', dot: 'bg-green-600' },
  yellow: { avatarBg: 'bg-yellow-100', avatarText: 'text-yellow-600', dot: 'bg-yellow-600' },
  default: { avatarBg: 'bg-gray-100', avatarText: 'text-gray-600', dot: 'bg-gray-600' },
};

export function isOptionDisplay(value: unknown): value is OptionDisplay {
  return (
    typeof value === 'object' &&
    value !== null &&
    'id' in value &&
    'label' in value &&
    typeof (value as OptionDisplay).label === 'string'
  );
}
